<template lang="pug">
.themenu(v-shortcuts="[{ shortcut: [ 'f9', ], callback: shortcuts, push: true, focus: true },]")
  modal-shortcuts
  modal-commission-config(:newRecord='newRecord', :is-add='isModalAdd')
  .nav-bar
    .img-container
      a(href="/")
        img.logo(src='@/assets/logo.png',alt='Logo')
    .menu-container
      vm-navbar(class="sub-nabar" text-color="black", type="flat")
        vm-navbar-item(index="0" v-for="(item, i) in menuItems" :key="i")
          router-link.item-list(:to='item.link')
            vm-icon(:icon="item.icon" size="1.4rem")
            span {{ $t(item.name) }}
        vm-dropdown.btn_config(vm-position="right" vm-trigger-click)
          vm-button.help(type="flat" radius text-color="black" icon="settings-outline" @click="")
            | Configuracion
          vm-dropdown-menu
            vm-dropdown-group(vm-label="Configuracion")
              vm-dropdown-item(@click="editCommission()") {{ $t('strings.commission_config') }}
            vm-dropdown-group(vm-label="Ayuda")
              vm-dropdown-item(@click="shortcuts()") {{ $t('strings.shortcuts') }}
            vm-dropdown-group(vm-label="Legal")
              vm-dropdown-item Términos de uso
              vm-dropdown-item Política de privacidad
    .bottom-menu
        vm-button(icon="power-outline" @click="logout")
            |{{ $t('login.logout') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ModalShortcuts from '@/components/aditionals/ModalShortcuts.vue'
import ModalCommissionConfig from '@/components/modals/ModalCommissionConfig.vue'
export default {
  name: 'TheMenu',
  components: {
    ModalShortcuts,
    ModalCommissionConfig
  },
  data: () => ({
    isModalAdd: true,
    newRecord: {},
    activeItem: 0
  }),
  computed: {
    ...mapGetters([
      'menuItems'
    ])
  },
  methods: {
    ...mapActions([
      'setModalShortcutsVisible',
      'setModalCommissionsVisible'
    ]),
    logout () {
      this.$auth.logout({
        makeRequest: true,
        redirect: { name: 'login' }
      })
    },
    shortcuts () {
      this.setModalShortcutsVisible(true)
    },
    editCommission (reception, index) {
      this.isModalAdd = true
      this.setModalCommissionsVisible(true)
      this.newRecord = { ...reception }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.themenu {
  height: 100%;
  display: flex;
  width: 250px;
  background: #f9f9f9;
  transition: width 300ms cubic-bezier(0.2, 0, 0, 1) 0s;
  padding: 20px 30px;
  border-right: .5px solid #a3a3a357;
  .nav-bar {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    .img-container {
      width: 100%;
      display: flex;
      justify-content: center;
      a {
        display:block;
        width: 100%;
        .logo {
          width: 75%;
          display: flex;
          margin: 10px 0px 50px 0px;
        }
      }
    }
    .sub-nabar {
      width: 100%;
      display: block;
      transform: translateY(-50%);
      top: 50%;
      .vm-navbar--item {
        .item-list {
          display: flex;
          flex-direction: row;
          font-size: 13px;
        }
        .router-link-active {
          color: #2ba5c6;
          font-weight: bold;
          i {
            color: #2ba5c6;
          }
          ~.vm-navbar-after {
              width: 100%;
          }
        }
        span {
          margin: 5px;
        }
        a {
          background-color: rgba(0, 0, 0, 0);
          padding: 10px 0px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }
    }
    .bottom-menu {
      width: 80%;
      display: flex;
      position: relative;
      padding-top: 70px;
      padding-bottom: 40px;
      bottom: 10px;
      justify-content: center;
      }
  }
  .btn_config {
    position: absolute;
    width: 100%;
    display: flex;
    font-size: 13px;
    .help {
      font-size: 13px;
      padding: 10px 0px;
      .vm-icon {
        font-size: 1.3rem;
      }
    }
  }
  .sub-menu {
    height: 100%;
    background-color: #1d49b6;
    width: 190px;
    position: relative;
  }
}
.heading {
  min-width: 180px;
  padding: 2px 12px;
  h4 {
    padding-top: 3px;
  }
}
.nonotifications {
  text-align: center;
}
.menu-container {
  width: 100%;
  display: flex;
}
</style>
